import * as Types from '../Constants/AllConstants';

// List all fees (unpaged)
export const GetAllFeesReducer = (state = { fees: [] }, action) => {
  switch (action.type) {
    case Types.FEE_LIST_REQUEST:
      return { loading: true };
    case Types.FEE_LIST_SUCCESS:
      return { loading: false, fees: action.payload };
    case Types.FEE_LIST_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

// Paginated fees
export const GetPagedFeesReducer = (state = { fees: [], page: 0, pages: 0 }, action) => {
  switch (action.type) {
    case Types.FEE_PAGED_REQUEST:
      return { loading: true };
    case Types.FEE_PAGED_SUCCESS:
      return {
        loading: false,
        fees: action.payload.content,
        page: action.payload.number,
        pages: action.payload.totalPages,
      };
    case Types.FEE_PAGED_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

// Fee details
export const FeeDetailsReducer = (state = { fee: {} }, action) => {
  switch (action.type) {
    case Types.FEE_DETAILS_REQUEST:
      return { loading: true };
    case Types.FEE_DETAILS_SUCCESS:
      return { loading: false, fee: action.payload };
    case Types.FEE_DETAILS_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

// Create fee
export const CreateFeeReducer = (state = {}, action) => {
  switch (action.type) {
    case Types.FEE_CREATE_REQUEST:
      return { loading: true };
    case Types.FEE_CREATE_SUCCESS:
      return { loading: false, success: true, fee: action.payload };
    case Types.FEE_CREATE_FAIL:
      return { loading: false, error: action.payload };
    case Types.FEE_CREATE_RESET:
      return {};
    default:
      return state;
  }
};

// Update fee
export const UpdateFeeReducer = (state = {}, action) => {
  switch (action.type) {
    case Types.FEE_UPDATE_REQUEST:
      return { loading: true };
    case Types.FEE_UPDATE_SUCCESS:
      return { loading: false, success: true, fee: action.payload };
    case Types.FEE_UPDATE_FAIL:
      return { loading: false, error: action.payload };
    case Types.FEE_UPDATE_RESET:
      return {};
    default:
      return state;
  }
};

// Delete fee
export const DeleteFeeReducer = (state = {}, action) => {
  switch (action.type) {
    case Types.FEE_DELETE_REQUEST:
      return { loading: true };
    case Types.FEE_DELETE_SUCCESS:
      return { loading: false, success: true };
    case Types.FEE_DELETE_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};
